
import { BlogSectionWrapper } from "./blogSection.style";
import { Container, Title, Text, Card, Image, Paper, Grid, Group, Button } from "@mantine/core";
import { IconShare } from "@tabler/icons-react";
import { blogPosts } from 'common/data/AppCreative';
import ShareBar from "containers/ShareBar";
import Link from "compat/Link";
import { useRouter } from "compat/router";

export function BlogPostsSection() {
    return (
        <BlogSectionWrapper>
            <Container size="md">
                <Grid>
                    {blogPosts.reverse().map((post, index) => (
                        <Grid.Col span={12} key={post.id}>
                            <Card shadow="sm" p="lg" radius="md" mb="lg">
                                <Image src={post.image} alt={post.title} radius="md" height={index === 0 ? 300 : 200} style={{ objectFit: 'cover' }} />
                                <Title order={3} mt="md">
                                    <Link href={`/blog/${post.id}`} style={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}>
                                        <Text>{post.title}</Text>
                                    </Link>
                                </Title>
                                <Text size="sm" color="dimmed" mb="xs">{post.date}</Text>
                                <Text>{post.content[0].content}</Text>
                                <Group position="apart" mt="md">
                                    <Button component={Link} href={`/blog/${post.id}`} variant="outline" size="sm" style={{borderRadius: 20}}>Continue Reading</Button>
                                    {/* <Button leftIcon={<IconShare size={16} />} variant="subtle" size="sm">Share</Button> */}
                                    <ShareBar url={`https://www.linoktech.com/blog/${post.id}`} title={post.title} />
                                </Group>
                            </Card>
                        </Grid.Col>
                    ))}
                </Grid>
            </Container>
        </BlogSectionWrapper>
    );
}
